import './ProgressCircle.scss'

import React, { Component } from 'react'
import cx from 'bem-classnames'

const CATEGORIES = {
  'high': 'High',
  'average': 'Average',
  'low': 'Low',
  'zero': '——'
}

export default class ProgressCircle extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  calculatePercentage = (val, min, max) => {
    return parseFloat(val) / (parseFloat(max) - parseFloat(min))
  }

  leadSourcesOptions = () => {
    let value = isNaN(this.props.value) ? '0' : (this.props.value.toFixed(1) || '0')
    let valueStr = `${value}%`
    let scaleMin = this.props.scaleMin || 0
    let scaleMax = this.props.scaleMax || 100
    let scaleVal = this.props.scaleVal || '215'

    let percentage = this.calculatePercentage(value, scaleMin, scaleMax) * 100
    let categorization = parseFloat(value) === 0 ? 'zero': this.props.categorization
    let text = CATEGORIES[categorization] || ''
    let strokeDashVal = (parseFloat(percentage) / 100) * scaleVal

    return {
      height: this.props.height || '140',
      width: this.props.width || '140',
      baseR: this.props.baseR || '60',
      progressR: this.props.progressR || '34',
      coverR: this.props.coverR || '53',
      scaleVal,
      value: valueStr,
      text,
      percentage,
      classType: categorization || '',
      strokeDashVal
    }
  }

  render() {
    let { percentage=0, categorization } = this.props
    let options

    switch (this.props.type) {
      case 'lead-sources':
        options = this.leadSourcesOptions()
        break;
      default:
        return null
    }

    const baseClasses = {
      name: 'ProgressCircle__base',
      modifiers: ['high', 'average', 'low', 'zero']
    }

    const progressClasses = {
      name: 'ProgressCircle__progress',
      modifiers: ['high', 'average', 'low', 'zero']
    }

    const textClasses = {
      name: 'ProgressCircle__text',
      modifiers: ['high', 'average', 'low', 'zero']
    }

    const { strokeDashVal } = options
    return (
      <div className="ProgressCircle">
        <svg width={options.width} height={options.height}>
          <circle r={options.baseR} cx="50%" cy="50%" className={cx(baseClasses, {[options.classType]: true})} />
          <circle r={options.progressR} cx="50%" cy="50%" className={cx(progressClasses, {[options.classType]: true})} style={{strokeDasharray: `${strokeDashVal}, ${options.scaleVal}`}} />
          <circle r={options.coverR} cx="50%" cy="50%" className="ProgressCircle__cover" />
        </svg>
        <div className={cx(textClasses, {[options.classType]: true})}>
          <div className="ProgressCircle__text--large">{options.value}</div>
          <div className="ProgressCircle__text--sub">{options.text}</div>
        </div>
      </div>
    )
  }
}
